import template from './tenants.jade';
import validation from './../../../services/validation';

export default angular.module('cian.addForm.aboutBuildingTenants', []).directive('cianAfAboutBuildingTenants', () => ({
  scope: {},
  bindToController: {
    ad: '=',
    form: '=',
  },
  controller(deviceService) {
    'ngInject';

    this.isMobile = deviceService.isMobile;
    this.validation = validation(this.form, 'building.tenants', {
      maxlength: 'Превышено ограничение',
    });
  },
  controllerAs: 'tenants',
  template,
})).name;
